var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/_core-js@2.4.1@core-js/library/modules/_has.js
 ** module id = 43
 ** module chunks = 0 1
 **/